(function () {
  'use strict';

  const wrap = document.querySelector('.c-stickyMenuWrap__menu');
  const ul = document.querySelector('.c-stickyMenu__list');
  if (!wrap || !ul) { return; }

  const li_all = ul.querySelectorAll('li');
  let active = '';

  function clearClass() {
    li_all.forEach((li) => {
      li.classList.remove('is-active');
    });
  }

  function scrollFunc() {
    const wh = window.innerHeight;

    for (let i = li_all.length - 1; i >= 0; i--) {
      const li = li_all[i];
      const a = li.querySelector('a[href^="#"]');
      if (!a) { return; }
      const href = a.getAttribute('href');
      if (href === '#top') {
        // top
        const rect = wrap.getBoundingClientRect();
        if (rect.top > wh / 4) {
          if (active !== href) {
            clearClass();
            li.classList.add('is-active');
          }
          break;
        }
      } else {
        // その他
        const target = document.querySelector(href);
        if (!target) { return; }

        const wh = window.innerHeight;
        const rect = target.getBoundingClientRect();
        //console.log(wh, rect);

        if (rect.top < wh / 4 && rect.bottom > 0) {
          if (active !== href) {
            clearClass();
            li.classList.add('is-active');
          }
          break;
        }
      }
    }


  }

  window.addEventListener('scroll', () => {
    scrollFunc();
  });
  window.addEventListener('touchmove', () => {
    scrollFunc();
  });
  scrollFunc();

})();
